var _onload_functions = new Array();

function onBodyLoad() {
  for(var i=0; i<_onload_functions.length; i++) {
    _onload_functions[i]();
  }
}